import React, { useState } from 'react';
import { get } from 'lodash';
import { SdfTabGroup, SdfTab, SdfBusyIndicator } from '@synerg/react-components';
import DevMilestones from './devMilestones';
import { ProjectCredentials } from './projectCredentials';
import ScopesAndAuthorization from './scopesAndAuthorization';
import TestInstance from './testInstance';
import ProdProjectDetails from './prodProjectDetails';
import SubscriptionsDetails from './subscriptionsDetails/subscriptionsDetails';
import { useApplicationState } from '../../../utilities/applicationState';
import ProjectWebhookDetails from './webhookDetails';
import { withConfig } from '../../../utilities/appConfig';

const PartnerProjectSteps = (props = {}) => {
	const {
		projectListData = {},
		getClientSecret,
		projectDetails,
		submitAppListingFields,
		webhookConfig,
		webhookError,
		webhookLoading,
		prodWebhookConfig,
		prodWebhookError,
		prodWebhookLoading,
		config
	} = props;
	const [activeStep, setActiveStep] = useState(0);
	/* eslint-disable no-unused-vars */
	const [changeRequestSubmitSuccessData, setChangeRequestSubmitSuccessData] = useState(null);
	const devDataCloudProject = get(projectDetails, 'platform', '') === 'datacloud';
	const [store, dispatch] = useApplicationState();
	const { projects: { current } } = store;
	const { devInfo, prodInfo = [] } = current;

	let legacyDevId;
	let legacyProdId;

	if ((projectDetails.legacy && projectDetails.type === 'DEV')) {
		legacyDevId = projectDetails._id;
		legacyProdId = get(projectDetails, 'associatedProject._id', null);
	} else if ((projectDetails.legacy && projectDetails.type === 'PROD')) {
		legacyProdId = projectDetails._id;
		legacyDevId = get(projectDetails, 'associatedProject._id', null);
	}
	let projId = projectDetails.legacy ? legacyDevId : devInfo._id;
	let prodProjId = projectDetails.legacy ? legacyProdId : prodInfo._id;

	const { loadings } = store;
	const { loadingProjectDetails = true } = loadings;
	const isProdDetailEnabled = !!projectListData.link || legacyProdId;

	// Get appconfig to check if webhooks feature is enabled
	const webhooksEnabled = config?.['webhookfeatureflag']?.enabled;


	return (
		<div className="mt-10 flex">
			{loadingProjectDetails &&
				<SdfBusyIndicator
					style={{ color: "#1a8099" }}
					size="xl"
					fullScreen={true}
					overlay={true}
				/>
			}
			<div className="pr-8">
				<SdfTabGroup vertical={true} size="small">
					<SdfTab active={activeStep === 0} onClick={() => setActiveStep(0)}>
						Credentials
					</SdfTab>
					{!projectListData.legacy && <SdfTab active={activeStep === 1} onClick={() => setActiveStep(1)}>
						Dev milestones
					</SdfTab>}
					{!projectDetails.legacy && !devDataCloudProject &&
						<SdfTab active={activeStep === 2} onClick={() => setActiveStep(2)}>
							Test instance
						</SdfTab>
					}
					<SdfTab active={activeStep === 3} disabled={!isProdDetailEnabled} onClick={isProdDetailEnabled ? () => setActiveStep(3) : null}>
						Production details
					</SdfTab>
					<SdfTab active={activeStep === 4} onClick={() => setActiveStep(4)}>
						Scope and authorization
					</SdfTab>
					<SdfTab active={activeStep === 5} onClick={() => setActiveStep(5)}>
						Subscriptions
					</SdfTab>
					{/* Only show Webhooks tab if feature flag is enabled */}
					{webhooksEnabled && (
						<SdfTab
							active={activeStep === 6}
							onClick={() => setActiveStep(6)}
							disabled={(webhookLoading || prodWebhookLoading) || (!webhookConfig && !prodWebhookConfig)}
							style={{ 
								display: (!webhookLoading && !prodWebhookLoading && (webhookConfig || prodWebhookConfig)) 
									? 'block' 
									: 'none' 
							}}
						>
							Webhooks
						</SdfTab>
					)}
				</SdfTabGroup>
			</div>
			<div className="flex-1">
				{activeStep === 0 &&
					<ProjectCredentials
						projectListData={projectListData}
						getClientSecret={getClientSecret}
					/>
				}
				{activeStep === 1 && <DevMilestones />}
				{activeStep === 2 && !projectDetails.legacy && !devDataCloudProject && (
					<TestInstance
						projectDetails={projectDetails}
						projectListData={projectListData}
					/>
				)}
				{activeStep === 3 &&
					<ProdProjectDetails projectListData={projectListData} getClientSecret={getClientSecret} submitAppListingFields={submitAppListingFields} />
				}
				{activeStep === 4 &&
					<ScopesAndAuthorization
						isTabActive={true}
						projectDetails={projectDetails}
						devProjectID={projId}
						prodProjectID={prodProjId}
						changeRequestSubmitSuccessData={changeRequestSubmitSuccessData}
					/>
				}
				{activeStep === 5 &&
					<SubscriptionsDetails
						projectDetails={projectDetails}
						projectID={projId}
						prodProjectID={prodProjId}
						projectListData={projectListData}
					/>
				}
				{/* Show error if webhook fetch failed and user is on Webhooks tab */}
				{webhooksEnabled && activeStep === 6 && webhookError && prodWebhookError && (
					<div className="text-danger-01 mt-8">
						{webhookError} / {prodWebhookError}
					</div>
				)}
				{/* Update webhook content rendering */}
				{webhooksEnabled && activeStep === 6 && (webhookConfig || prodWebhookConfig) && (
					<ProjectWebhookDetails 
						devWebhookConfig={webhookConfig}
						prodWebhookConfig={prodWebhookConfig}
						devWebhookError={webhookError}
						prodWebhookError={prodWebhookError}
					/>
				)}
			</div>
		</div>
	);
};

export default withConfig(PartnerProjectSteps);